/**
 * Side-effecting layer: takes a successful ParseResult and writes both rows
 * to IndexedDB inside a single transaction. Lives outside parse.ts so the
 * pure parser stays unit-testable without touching Dexie.
 */
import { db } from '$lib/storage'
import type { ImportedCity, Plan } from '$lib/types'
import * as settingsStore from '$lib/storage/settings'
import { invalidateImport } from '$lib/catalogue'
import type { ParseSuccess } from './parse'

export interface PersistedImport {
  importedCityId: number
  planId: number
}

export async function persistImport(result: ParseSuccess): Promise<PersistedImport> {
  let importedCityId = 0
  let planId = 0

  await db.transaction('rw', db.imports, db.plans, async () => {
    importedCityId = await db.imports.add(result.importedCity as unknown as ImportedCity)
    planId = await db.plans.add({
      ...result.initialPlan,
      importedCityId,
    } as unknown as Plan)
  })

  // The transient `id: -1` cache entries from parse-time can be cleared now;
  // future renders will re-resolve under the real id.
  invalidateImport(-1)

  await settingsStore.setLastOpenedPlan(planId)

  return { importedCityId, planId }
}
